import React, { ReactElement } from 'react';
import './dashboard.less';
import NestedRoute from '../../shared/components/tabs/NestedRoute';
import { getMappedRoute } from '../../utils/routeUtility';
import { DASHBOARD_NESTED_ROUTE } from '../../config/route/NestedRoutesConfig';
import CommonTab from '../../shared/components/tabs/CommonTab';
import { canActivate } from '../../utils/utility';

const Dashboard = ({ match, location }: any): ReactElement => {

  const activeDashboardRouts =
    DASHBOARD_NESTED_ROUTE.filter((nr: any): any => canActivate(nr.accessCheckKeyword));

  const nextDefaultPage =
    getMappedRoute(location?.pathname, DASHBOARD_NESTED_ROUTE) ||
    activeDashboardRouts[0].routeName;

  return (
    <NestedRoute
      match={match}
      defaultPage={nextDefaultPage}
      nestedNav={activeDashboardRouts}
      commonComponent={CommonTab}
    />
  );
};

export default Dashboard;
